var LoadingMixin = {
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    showLoading() {
      window.app.$children[0].showLoading();
    },
    hideLoading() {
      window.app.$children[0].hideLoading();
    },
  },
};

export { LoadingMixin };
